import { useEffect, useRef, useState } from "react";
import styles from "./DottedPill.module.scss";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import { getTradeLaneName } from "@containers/TradeLanesProfile/utils/helpers";
import { profileTypeEnum } from "../profile-enum";
import axios from "axios";
import { apiEndPoints } from "@containers/TradeLanesProfile/utils/enum";
import { getIntelUrl } from "@utils/intelUrl";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { generateQueryString } from "@core/utility/utility";
import { redirectingProfileEnum } from "@core/global/global-country-dictionary";
import { ChevronDown } from "react-feather";

const DottedPill = ({ value, backgroundColor, textColor, borderColor, borderWidth, dropdownItems = [], profileType }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const dropdownRef = useRef(null);
  const { location } = useHistory();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleRedirection = async (e, profileId) => {
    e.stopPropagation();
    try {
      let params = {
        profile_type: profileTypeEnum.ports,
        _id: profileId,
      };
      const { search } = location;
      const countryName = new URLSearchParams(search).get("country");
      const countryType = new URLSearchParams(search).get("type");

      const dataSource = new URLSearchParams(search).get("dataSource");
      const response = await axios.post(apiEndPoints.getProfileSlug, params);
      const queryParams = {
        country: countryName ? (countryName.toUpperCase() === "US" ? countryName.toUpperCase() : countryName.toLowerCase() === "united kingdom" ? "uk" : countryName.toLowerCase()) : "colombia",
        type: countryType ? countryType.toLowerCase() : "export",
        profileName: profileType,
        dataSource: dataSource,
      };
      const queryString = generateQueryString(queryParams);
      let url = `${getIntelUrl()}${redirectingProfileEnum[profileType]?.redirectionType}/${response?.data?.data?.slug}/${response?.data?.data?.redirection_id}` + "?" + queryString;
      window.open(url, "_blank");
      setShowDropdown(false);
    } catch (err) {
      toast.error("No profile found in our system !!!");
    }
  };

  return value ? (
    <div
      className={styles.dottedPillContainer}
      style={{
        backgroundColor: backgroundColor ?? "",
        color: textColor ?? "",
        border: `dashed ${borderWidth} ${borderColor}`,
      }}
      ref={dropdownRef}
      onClick={() => setShowDropdown(!showDropdown)}>
      <span>
        {value}
        <ChevronDown size={14} />
      </span>
      {showDropdown && dropdownItems?.length > 0 ? (
        <div className={`${styles.dropdownMenu} ${showDropdown ? styles.showTransition : ""}`}>
          {dropdownItems.map(({ _id, key }) => (
            <div key={_id} className={styles.dropdownItem} onClick={(e) => handleRedirection(e, _id)}>
              <span>{getTradeLaneName(key)}</span>
              {!isImageLoaded ? <LoadingSkeleton height={"20px"} width={"20px"} shape={"square"} /> : null}
              <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1711004025/intel/icons/open_in_new_q7xcmq.svg" alt="redirecion-img" onLoad={() => setIsImageLoaded(true)} style={{ display: !isImageLoaded && "none" }} />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  ) : null;
};

export default DottedPill;
